import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { LanguageContextProvider, MessageContextProvider, UserInfoContextProvider } from '../../React/Common/Contexts'
import { TeamsAuth } from '../../React/TeamsAuth/Main/TeamsAuth'

@Route(RouteID.TEAMS_AUTH)
export class TeamsAuthPage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.TEAMS_AUTH}>
                <div className='teams-auth-container'>
                    <MessageContextProvider>
                        <LanguageContextProvider>
                            <UserInfoContextProvider>
                                <TeamsAuth isRouterMode />
                            </UserInfoContextProvider>
                        </LanguageContextProvider>
                    </MessageContextProvider>
                </div>
            </RouteGuard>
        )
    }
}
